const ITEMS = [
  "REAL ESTATE",
  "EQUITIES",
  "PRIVATE EQUITY",
  "BUILD. HOLD. GROW.",
  "LONG-TERM PERSPECTIVE",
  "STUTTGART",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee"
      className="overflow-hidden border-y border-[#D4AF37]/15 py-10 sm:py-14"
    >
      <div className="marquee-track items-center">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`f-display whitespace-nowrap text-4xl font-light tracking-wide sm:text-6xl ${
                i % 4 === 3 ? "text-gold-metallic" : "gold-outline"
              }`}
            >
              {t}
            </span>
            <span className="mx-10 text-2xl text-[#D4AF37]/70 sm:mx-14">&mdash;</span>
          </span>
        ))}
      </div>
    </section>
  );
}
